<template>
    <div>
        <form @submit.prevent="pressOk">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Correo</strong>

                        <div class="input-group">
                            <input
                            type="email"
                            v-model="user.email"
                            class="form-control no-limited"
                            />

                            <div class="input-group-append">
                            <button
                                class="btn btn-outline-primary"
                                type="button"
                                @click="searchUser"
                            >
                                <i class="fa fa-search"></i>
                            </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Nombres</strong>
                        <input type="text" v-model="user.firstName" class="form-control no-limited" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Apellidos</strong>
                        <input type="text" v-model="user.lastName" class="form-control no-limited" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Perfiles</strong>
                        <v-select multiple v-model="user.roles" :options="roles"></v-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Teléfono</strong>
                        <input type="text" v-model="user.phoneNumber" class="form-control no-limited" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>Activo</strong>
                        <b-form-checkbox v-model="user.isActive" switch></b-form-checkbox>                    
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <button class="btn btn-block btn-success">
                            <i class="fa fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            roles: [],
            adUserFound: false,
            Post,
            Get
        };
    },
    props: ["user"],
    created() {
        this.getRoles();
    },
    watch: {
        "user.email"(newVal, oldVal) {
            if (oldVal && this.adUserFound && newVal !== oldVal) {
                this.user.firstName = "";
                this.user.lastName = "";
                this.adUserFound = false;
            }
        }
    },

    methods: {
        pressOk() {
            if (this.user) {
                var valid = true;
                var message = "Agregue o corrija los siguiente campos:<br>";
                if (!this.user.firstName) {
                    message = message + "* Nombre.<br>";
                    valid = false;
                }
                if (!this.user.lastName) {
                    message = message + "* Apellido.<br>";
                    valid = false;
                }
                if (!this.user.email) {
                    message = message + "* Correo.<br>";
                    valid = false;
                }
                if (!this.user.roles || this.user.roles.length == 0) {
                    message = message + "* Perfil.<br>";
                    valid = false;
                }
                if (valid) {
                    this.user.username = this.user.email;
                    this.$emit("pressOk");
                } else {
                    toastr.info(message);
                }
            }
        },
        getRoles() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/roles", res => {
                res.data.forEach(elements => {
                    this.roles.push(elements.name);
                });
                this.$store.commit("setLoading", false);
            });
        },
        searchUser() {
            if (!this.user.email) {
                toastr.info("Ingrese un correo para buscar");
                return;
            }

            this.$store.commit("setLoading", true);

            this.Get(
                this.apiUrl + "v1/users/ad?email=" + this.user.email,
                (res) => {
                    this.$store.commit("setLoading", false);

                    const response = res.data;

                    if (response.statusCode === 403) {
                        toastr.warning(response.message);
                        return;
                    }

                    if (response.statusCode === 404) {
                        toastr.info(response.message);
                        return;
                    }

                    if (response.statusCode === 200 && res?.data.data) {
                        this.$set(this.user, 'firstName', res.data.data.userFirstName)
                        this.$set(this.user, 'lastName', res.data.data.userLastName)
                        this.adUserFound = true;
                        toastr.success(response.message);
                    }
                },
                () => {
                    this.$store.commit("setLoading", false);
                    toastr.error("Error al consultar usuario");
                }
            );
        }
    }
};
</script>
